import moment from 'moment';
import { React, useMemo, useState } from 'react';
import {
    getMAJAA010Payments,
    getMAJAA010TicketsPurchase,
    getMAJAA010TicketsRefund,
    getMAJAA010TicketsUsed,
} from '../../../services/Api';
import Loader from '../../../shared/components/Loader';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_STATISTICAL } from '../../../shared/constants/app';
const MAJAA010 = () => {
    const today = moment().toDate();
    const [analyticsTime, setanalyticsTime] = useState({
        year: moment(today).format('YYYY'),
        month: moment(today).format('MM'),
    });
    const [loading, setLoading] = useState(false);
    const yearOptions = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const minYear = 2015;
        const years = [];
        for (let year = currentYear; year >= minYear; year--) {
            years.push(year);
        }
        return years;
    }, []);

    const getDropdownValues = (e) => {
        const { name, value } = e.target;
        setanalyticsTime((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const downloadFunctions = {
        Payments: getMAJAA010Payments,
        TicketsPurchase: getMAJAA010TicketsPurchase,
        TicketsRefund: getMAJAA010TicketsRefund,
        TicketsUsed: getMAJAA010TicketsUsed,
    };

    const handleDownLoad = (pathKey, namefile) => {
        if (!analyticsTime || !analyticsTime.year || !analyticsTime.month) {
            alert('월과 년도 선택해 주세요');
            return;
        }
        setLoading(true);
        const downloadFunction = downloadFunctions[pathKey];
        downloadFunction(analyticsTime)
            .then((res) => {
                let fileName = `${namefile}.xls`;
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Download error:', error);
                setLoading(false);
            });
    };

    return (
        <div className="container-fluid container statis-page">
            <div className="statistics-sale-history wrap">
                <SideMenu menu={MENU_STATISTICAL} />
                <div className="sale-history-management content-right">
                    <div className="title">매출내역관리</div>
                    <div className="group-content">
                        <div className="title-name">[덴탈잡 매출내역 다운]</div>
                        <div className="select-box">
                            <select name="year" onChange={getDropdownValues} value={analyticsTime.year || ''}>
                                <option value="">YYYY</option>
                                {yearOptions.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                            년
                            <select name="month" onChange={getDropdownValues} value={analyticsTime.month}>
                                <option value={null}>MM</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select>
                            월
                        </div>
                        <div className="wrap-button">
                            <div className="wrap-tiem">
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'Payments',
                                            `덴탈잡 집계내역_${analyticsTime.year}${analyticsTime.month}`,
                                        );
                                    }}
                                >
                                    덴탈잡 집계내역
                                </button>
                            </div>
                            <div className="wrap-tiem">
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'TicketsPurchase',
                                            `덴탈잡 이용권 구매내역_${analyticsTime.year}${analyticsTime.month}`,
                                        );
                                    }}
                                >
                                    덴탈잡 이용권 구매내역
                                </button>{' '}
                                -&gt; 구매일기준
                            </div>
                            <div className="wrap-tiem">
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'TicketsRefund',
                                            `덴달잡 이용권 환물(취소)내역_${analyticsTime.year}${analyticsTime.month}`,
                                        );
                                    }}
                                >
                                    덴탈잡 이용권 환불(취소)내역
                                </button>{' '}
                                -&gt; 환불(취소)일 기준
                            </div>
                            <div className="wrap-tiem">
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'TicketsUsed',
                                            `덴탈잡 이용권 사용내역_${analyticsTime.year}${analyticsTime.month}`,
                                        );
                                    }}
                                >
                                    덴탈잡 이용권 사용내역
                                </button>{' '}
                                -&gt; 사용일 기준
                            </div>
                        </div>
                        <div className="wanning-alert">
                            ※ 다운받은 파일은 반드시 엑셀형식으로 다시 저장해서 사용하세요.
                        </div>
                        {loading ? <Loader /> : ''}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAJAA010;
